/**
 * A screen's actions (Add dimension, Edit prompt) on the line of the switch
 * that chose the screen, instead of a row of their own. The container renders
 * `<SectionActionsSlot>` where the actions go; the screen wraps its buttons in
 * `<SectionActions>`, which portals them there. Without a slot (a screen
 * shown on its own) they render in place, right-aligned.
 */

import { createContext, useContext, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

const Slot = createContext<HTMLElement | null | undefined>(undefined);

export function SectionActionsProvider({ children }: { children: (slotRef: (node: HTMLElement | null) => void) => ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return <Slot.Provider value={slot}>{children(setSlot)}</Slot.Provider>;
}

export function SectionActions({ children }: { children: ReactNode }) {
  const slot = useContext(Slot);
  if (slot === undefined) return <div className="tab-toolbar"><div className="page-actions">{children}</div></div>;
  return slot ? createPortal(children, slot) : null;
}
